import React from "react";
import Card from "@mui/material/Card";
import { CardHeader, Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { getTimeFromNow } from "../../../functions/time";
import { sanitizeAllowed } from "../../../functions/html";
import AttachmentList from "../../../components/AttachmentList/AttachmentList";
import DocumentLayout from "../../../components/Layouts/DocumentLayout";
import MessagesSection from "./MessagesSection";
import { getCardHeader } from "./ticketDetailUtils";

const CreatedAt = (props) => (
  <Typography component="p" color="textSecondary">
    {props.item.updatedAt || props.item.createdAt}
  </Typography>
);

const TicketDetailItemPrivate = (props) => {
  const { item } = props;
  const attachments = item.attachments || [];
  const cardHeader = getCardHeader(item, attachments);

  return (
    <DocumentLayout>
      <Card>
        <CardHeader title={cardHeader.title} subheader={cardHeader.subheader} />

        {/* attachments section */}
        {attachments && attachments.length > 0 && (
          <>
            <Divider />
            <AttachmentList attachments={attachments} />
          </>
        )}

        {item.document && item.document.body && (
          <>
            <Divider />
            <CardContent>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeAllowed(item.document.body),
                }}
              />
            </CardContent>
          </>
        )}

        <CardContent>
          <CreatedAt
            item={{
              createdAt: getTimeFromNow(item.createdAt),
              updatedAt: getTimeFromNow(item.updatedAt),
            }}
          />
        </CardContent>

        {/* messages section */}
        <MessagesSection />
      </Card>
    </DocumentLayout>
  );
};

export default TicketDetailItemPrivate;
